import * as tslib_1 from "tslib";
import { BaseApiClient } from './BaseApiClient';
export var RACES_ENDPOINTS = {
    BY_ID: '/Races/{0}',
    ALL: '/Races',
    COMPACT: '/Races/Compact'
};
/**
 * RacesApiClient - client for fetching races from BFF
 * @exports
 * @class RacesApiClient
 * @extends BaseApiClient
 */
var RacesApiClient = /** @class */ (function (_super) {
    tslib_1.__extends(RacesApiClient, _super);
    function RacesApiClient() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get a race by race id from BFF
     * @param {string} raceId id of a race
     * @throws {RequiredError}
     * @memberof RacesApiClient
     */
    RacesApiClient.prototype.getById = function (raceId) {
        var fetchOptions = {
            request: {},
            fetchOptOverride: {
                method: "GET",
                headers: {
                    "Cache-Control": "no-cache"
                }
            }
        };
        return this.executeRequest(RACES_ENDPOINTS.BY_ID.format(raceId), fetchOptions);
    };
    /**
     * Get all races from BFF
     * @throws {RequiredError}
     * @memberof RacesApiClient
     */
    RacesApiClient.prototype.getRaces = function () {
        var fetchOptions = {
            request: {},
            fetchOptOverride: {
                method: "GET",
                headers: {
                    "Cache-Control": "no-cache"
                }
            }
        };
        return this.executeRequest(RACES_ENDPOINTS.ALL, fetchOptions);
    };
    /**
     * Get all races with no participants and tote details from BFF
     * @throws {RequiredError}
     * @memberof RacesApiClient
     */
    RacesApiClient.prototype.getRacesCompact = function () {
        var fetchOptions = {
            request: {},
            fetchOptOverride: {
                method: "GET",
                headers: {
                    "Cache-Control": "no-cache"
                }
            }
        };
        return this.executeRequest(RACES_ENDPOINTS.COMPACT, fetchOptions);
    };
    return RacesApiClient;
}(BaseApiClient));
export { RacesApiClient };
//# sourceMappingURL=RacesApiClient.js.map